import { Button, Icon, Modal } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

interface DisablePartnershipModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  partnershipName: string;
}

export const DisablePartnershipModal = ({
  isOpen,
  onClose,
  onConfirm,
  partnershipName,
}: DisablePartnershipModalProps) => {
  const { t } = useTranslation();
  const prefix = 'tariffAndTuition.partnerships';

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="md">
      <Row className="text-center py-4 px-3">
        <Col xs={12}>
          <Icon name="warning" color="secondary" size="65px" />
        </Col>
        <Col xs={12} className="py-4">
          <span className="fs-20 text-dark">
            {t(`${prefix}.disableModal.title`)}
          </span>
        </Col>
        <Col xs={12}>
          <p className="fs-18 fw-300">
            {t(`${prefix}.disableModal.description`, {
              name: partnershipName,
            })}
          </p>
        </Col>
      </Row>
      <Row className="pt-3 pb-4">
        <Col xs={12} md={6} className="pb-2 pb-md-0">
          <Button
            text={t('common.actions.cancel')}
            type="button"
            outlined
            onClick={onClose}
            fullwidth
          />
        </Col>
        <Col xs={12} md={6}>
          <Button
            text={t(`${prefix}.disable`)}
            type="button"
            onClick={onConfirm}
            fullwidth
          />
        </Col>
      </Row>
    </Modal>
  );
};
